var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7c-1.67 0-3.02 1.35-3.02 3s1.35 3 3.02 3 3.02-1.35 3.02-3S13.67 7 12 7ZM0 12C0 5.37 5.37 0 12 0s12 5.37 12 12c0 3.34-1.36 6.36-3.56 8.53A11.989 11.989 0 0 1 12 24c-3.29 0-6.27-1.32-8.44-3.47A11.94 11.94 0 0 1 0 12Zm18.58 7.53C17.58 16.89 15.01 15 12 15c-3.01 0-5.58 1.88-6.58 4.53A9.953 9.953 0 0 0 12 22c2.52 0 4.82-.93 6.58-2.47ZM12 2C6.48 2 2 6.48 2 12c0 2.22.72 4.27 1.94 5.92a9.06 9.06 0 0 1 4.64-4.26A4.96 4.96 0 0 1 6.98 10c0-2.77 2.25-5 5.02-5 2.77 0 5.02 2.23 5.02 5 0 1.45-.62 2.75-1.6 3.66a9.06 9.06 0 0 1 4.64 4.26A9.97 9.97 0 0 0 22 12c0-5.52-4.48-10-10-10Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export default ForwardRef;